var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"splash tw-flex tw-items-center tw-justify-center tw-w-full tw-bg-white"},[_c('img',{staticClass:"tw-h-full",attrs:{"alt":"Embajadores BeerOffice","src":require("@/assets/img/show-me/botella.gif")}})])
}]

export { render, staticRenderFns }